// extracted by mini-css-extract-plugin
export default {"invalidEmailMessage":"styles_invalidEmailMessage__8Od1f"};